import { render, staticRenderFns } from "./ConfigsPanel.vue?vue&type=template&id=eff0f940&scoped=true"
import script from "./ConfigsPanel.vue?vue&type=script&lang=js"
export * from "./ConfigsPanel.vue?vue&type=script&lang=js"
import style0 from "./ConfigsPanel.vue?vue&type=style&index=0&id=eff0f940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff0f940",
  null
  
)

export default component.exports